import { BellFilled } from '@ant-design/icons';
import useReminderState from 'hooks/useReminderState';
import posthog from 'posthog-js';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SymptomTrackingReminderModal from './modals/SymptomTrackingReminderModal';
import { Button } from 'components/ui';
import { colors } from 'design';

export type SymptomTrackingReminderProps = {
  mode: 'full' | 'iconOnly' | 'callToAction';
  onReminderEnabled?: () => void;
  hidePeriodReminder?: boolean;
  hideDailyReminder?: boolean;
};

const SymptomTrackingReminder: React.FC<SymptomTrackingReminderProps> = ({
  mode,
  onReminderEnabled,
  hidePeriodReminder = false,
  hideDailyReminder = false,
}) => {
  const { t } = useTranslation();
  const [showNotificationScheduleModal, setShowNotificationScheduleModal] = useState<boolean>(false);

  const { reminderTime, isPeriodReminderEnabled, areDailyNotificationsEnabled } = useReminderState();

  const showReminderModal = () => {
    setShowNotificationScheduleModal(true);
    posthog.capture('tracking.reminder_modal_opened');
  };

  const handleCloseModal = () => {
    setShowNotificationScheduleModal(false);
  };

  const getIconColor = () => {
    if (mode === 'callToAction') {
      return 'white';
    }
    if (areDailyNotificationsEnabled || isPeriodReminderEnabled) {
      return colors.brand.accentStrong;
    }
    return colors.text.tertiary;
  };

  return (
    <>
      <Button
        variant={mode === 'callToAction' ? 'primary' : 'secondary'}
        size="lg"
        onClick={showReminderModal}
        style={mode === 'callToAction' ? {} : { color: colors.text.tertiary }}
      >
        {mode == 'callToAction' && t('symptomTracking.reminder.callToAction')}

        {mode == 'full' &&
          (areDailyNotificationsEnabled && reminderTime ? (
            /* Daily reminder is active : display time */
            <>
              {t('symptomTracking.reminder.active')} :{' '}
              <b>
                {reminderTime.hour.toString().padStart(2, '0')}:{reminderTime.minute.toString().padStart(2, '0')}
              </b>
            </>
          ) : (
            /* Daily reminder is inactive  */
            t('symptomTracking.reminder.inactive')
          ))}

        <BellFilled style={{ color: getIconColor() }} />
      </Button>
      <SymptomTrackingReminderModal
        isOpen={showNotificationScheduleModal}
        onClose={handleCloseModal}
        onReminderEnabled={onReminderEnabled}
        hidePeriodReminder={hidePeriodReminder}
        hideDailyReminder={hideDailyReminder}
      />
    </>
  );
};

export default SymptomTrackingReminder;
